
var editor = ace.edit("editor");
editor.setTheme("ace/theme/monokai");
editor.session.setMode("ace/mode/html");

function generateHTML() {
    const mobImageUrl1 = document.getElementById("mobImageUrl1").value;
    const deskImageUrl1 = document.getElementById("deskImageUrl1").value;
    const mobImageUrl2 = document.getElementById("mobImageUrl2").value;
    const deskImageUrl2 = document.getElementById("deskImageUrl2").value;
    const categoryId1 = document.getElementById("categoryId1").value;
    const subtitle1 = document.getElementById("subtitle1").value;
    const title1 = document.getElementById("title1").value;
    const promoText1 = document.getElementById("promoText1").value;
    const buttonText1 = document.getElementById("buttonText1").value;
    const categoryId2 = document.getElementById("categoryId2").value;
    const promoText2 = document.getElementById("promoText2").value;
    const buttonText2 = document.getElementById("buttonText2").value;

    let htmlCode = `<link href="MEDIA/font/Font.css?$staticlink$" rel="stylesheet">
<link href="MEDIA/css/HP_bloc_Double/HP_bloc_Double.css?$staticlink$" rel="stylesheet">
<style>
.bloc-double-custom .bloc-etam {
    background-image: url("${mobImageUrl1}");
}
@media screen and (min-width: 1024px) {
    .bloc-double-custom .bloc-etam {
        background-image: url("${deskImageUrl1}");
    }
}
.bloc-double-custom .bloc-newCo {
    background-image: url("${mobImageUrl2}");
}
@media screen and (min-width: 1024px) {
    .bloc-double-custom .bloc-newCo {
        background-image: url("${deskImageUrl2}");
    }
}
</style>
<!-- Content of the blocks dynamically generated based on inputs -->
<div class="HpBackground section js-voletAnim js-scrollAnim js-fullBannerAnim" data-section="SOLDES & BRODERIE" data-color="-white">
<section class="bloc-double-custom">
    <article class="bloc-double-custom--item">
        <a href="$url('Search-Show','cgid','${categoryId1}')$" class="bloc-etam">
            <div class="bloc-title">
                <h4 class="-bg-pink -font-white -box-shadow"><span>${subtitle1}</span></h4>
                <h2 class="-font-msoulmaze -text-shadow -font-white -big-title">${title1}</h2>
                <h3 class="-bg-pink -font-white -medium-title -flex -flex-x-center"><span>${promoText1}</span></h3>
                <button class="mt-24 btn btn-secondary x-upper -white">${buttonText1}</button>
            </div>
        </a>
    </article>
    <article class="bloc-double-custom--item x-display-desktop-flex">
        <a href="$url('Search-Show','cgid','${categoryId2}')$" class="bloc-newCo">
            <div class="bloc-newCo--item">
                <h2 class="heading-01 x-upper x-white">${promoText2.replace(/<br>/g, '\n')}</h2>
                <button class="mt-24 btn btn-secondary x-upper -white">${buttonText2}</button>
            </div>
        </a>
    </article>
</section>
</div>

<!-- Bloc HP mobile -->
<div class="d-md-none hideDesktop HpBackground section js-voletAnim js-scrollAnim js-fullBannerAnim" data-section="BRODERIE" data-color="-white">

    <section class="bloc-double-custom">

        <!-- Bloc de droite -->
        <article class="bloc-double-custom--item">

            <!--  -->
            <a href="$url('Search-Show','cgid','${categoryId2}')$" class="bloc-newCo">

                <div class="bloc-newCo--item">

                    <h2 class="heading-01 x-upper x-white">
                    ${promoText2.replace(/<br>/g, '\n')}
                    </h2>

                    <button class="mt-24 btn btn-secondary x-upper -white">
                    ${buttonText2}
                    </button>

                </div>

            </a>

        </article>

    </section>

</div>
`;

editor.session.setValue(htmlCode);

}

document.querySelector(".button-html").addEventListener("click", generateHTML);
